import { Empty } from '@rematter/ui-web';
import { LucideCalendarOff, LucideLayers, LucideLock } from 'lucide-react';

import { useTranslations } from '../i18n/useTranslations';

interface CalendarEmptyStateProps {
  variant: 'no-layers' | 'no-events' | 'no-access';
}

const iconMap = {
  'no-layers': <LucideLayers className="size-12 text-neutral/30" />,
  'no-events': <LucideCalendarOff className="size-12 text-neutral/30" />,
  'no-access': <LucideLock className="size-12 text-neutral/30" />,
} as const;

export const CalendarEmptyState = ({ variant }: CalendarEmptyStateProps) => {
  const t = useTranslations();

  const config = {
    'no-layers': {
      title: t.emptyState.noLayers.title,
      description: t.emptyState.noLayers.description,
    },
    'no-events': {
      title: t.emptyState.noEvents.title,
      description: t.emptyState.noEvents.description,
    },
    'no-access': {
      title: t.emptyState.noAccess.title,
      description: t.emptyState.noAccess.description,
    },
  } as const;

  const { title, description } = config[variant];

  return (
    <Empty
      title={title}
      description={description}
      icon={iconMap[variant]}
      size="md"
      className="@CalendarEmptyState"
    />
  );
};
